import React, { useState, useEffect } from "react";
import Chip from "@material-ui/core/Chip";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
  chip: {
    fontSize: 12,
    backgroundColor: "#fff",
    color: "#1B2027",
    borderColor: "#fff",
  },
  clear: {
    backgroundColor: "#1B2027",
    color: "#fff",
    cursor: "pointer",
    "&:hover, &:focus": {
      backgroundColor: "#1B2027 !important",
    },
  },
}));
export default function SelectedFilter(props) {
  const classes = useStyles();
  const {
    prescriptionFilter,
    term,
    mobileFilter,
    start,
    end,
    status,
    handleAppointmentStatus,
    appointmentStatus,
    handleDate,
    handleConsultation,
    resetFilter,
    mobileFilterData,
    selectedConsultation,
    selectedAppointmentStatus,
    allDoctorsRelatedData,
    handleDoctorList,
    selectedDoctorsRelatedData,
  } = props;
  const [doctorListData, setDoctorListData] = useState(null);
  const [consulatationData, setConsulatationData] = useState(null);
  const [appointmentData, setAppointmentData] = useState(null);
  const [prescriptionData, setPrescriptionData] = useState(null);
  useEffect(() => {
    setDoctorListData(
      mobileFilterData?.allDoctorsRelatedData
        ? mobileFilterData?.allDoctorsRelatedData
        : null
    );
    setConsulatationData(
      mobileFilterData?.status ? mobileFilterData?.status : null
    );
    setAppointmentData(
      mobileFilterData?.appointmentStatus
        ? mobileFilterData?.appointmentStatus
        : null
    );
    setPrescriptionData(
      mobileFilterData?.prescriptionStatus
        ? mobileFilterData?.prescriptionStatus
        : null
    );
  }, [mobileFilter, mobileFilterData]);

  const deleteDoctorList = () => {
    setDoctorListData(null);
    delete mobileFilterData["allDoctorsRelatedData"];
    localStorage.removeItem("patientDoctorName");
    handleDoctorList();
  };

  const deleteConsultation = () => {
    setConsulatationData(null);
    delete mobileFilterData["status"];
    handleConsultation();
  };

  const deleteAppointmentStatus = () => {
    handleAppointmentStatus();
    delete mobileFilterData["appointmentStatus"];
    setAppointmentData(null);
  };
  const deletePrescriptionStatus = () => {
    prescriptionFilter({ prescription_filter: "" });
    delete mobileFilterData["prescriptionStatus"];
    setPrescriptionData(null);
  };
  const resetAllFilter = () => {
    setConsulatationData(null);
    setAppointmentData(null);
    setPrescriptionData(null);
    resetFilter();
  };

  let doctorName = JSON.parse(localStorage.getItem("patientDoctorName"));

  return (
    <div className={classes.root}>
      {mobileFilter && term?.start_date && term?.end_date && (
        <Chip
          label={`Selected Period: ${term?.start_date} to ${term?.end_date}`}
          onDelete={handleDate}
          className={classes.chip}
          variant="outlined"
        />
      )}
      {!mobileFilter && start && end && (
        <Chip
          label={`Selected Period: ${start} to ${end}`}
          onDelete={handleDate}
          className={classes.chip}
          variant="outlined"
        />
      )}

      {mobileFilter && appointmentData && (
        <Chip
          label={`Appointment Status: ${appointmentData?.name}`}
          onDelete={deleteAppointmentStatus}
          className={classes.chip}
          variant="outlined"
        />
      )}

      {mobileFilter && prescriptionData && (
        <Chip
          label={`Prescription: ${prescriptionData?.name}`}
          onDelete={deletePrescriptionStatus}
          className={classes.chip}
          variant="outlined"
        />
      )}

      {mobileFilter && doctorListData && (
        <Chip
          label={`Consultation: ${doctorListData?.name}`}
          onDelete={deleteConsultation}
          className={classes.chip}
          variant="outlined"
        />
      )}

      {mobileFilter && allDoctorsRelatedData && (
        <Chip
          label={`Doctor Name: ${allDoctorsRelatedData?.name}`}
          onDelete={deleteDoctorList}
          className={classes.chip}
          variant="outlined"
        />
      )}

      {mobileFilter &&
        ((term?.start_date && term?.end_date) ||
          consulatationData ||
          appointmentData ||
          prescriptionData ||
          doctorListData) && (
          <Chip
            label="Clear All Filter"
            className={classes.clear}
            variant="outlined"
            onClick={resetAllFilter}
          />
        )}
      {!mobileFilter &&
        selectedAppointmentStatus &&
        selectedAppointmentStatus?.name && (
          <Chip
            label={`Appointment Status: ${selectedAppointmentStatus?.name}`}
            onDelete={handleAppointmentStatus}
            className={classes.chip}
            variant="outlined"
          />
        )}
      {!mobileFilter && selectedConsultation && selectedConsultation?.name && (
        <Chip
          label={`Consultation: ${selectedConsultation?.name}`}
          onDelete={handleConsultation}
          className={classes.chip}
          variant="outlined"
        />
      )}
      {!mobileFilter && doctorName && doctorName?.name && (
        <Chip
          label={`Doctor Name: ${doctorName?.name}`}
          onDelete={handleDoctorList}
          className={classes.chip}
          variant="outlined"
        />
      )}
      {!mobileFilter &&
        ((start && end) ||
          (selectedAppointmentStatus && selectedAppointmentStatus?.name) ||
          (selectedConsultation && selectedConsultation?.name) ||
          (doctorName && doctorName?.name)) && (
          <Chip
            label="Clear All Filter"
            className={classes.clear}
            variant="outlined"
            onClick={resetFilter}
          />
        )}
    </div>
  );
}
